import React from 'react';
import { CircleOff, AlertCircle, CheckCircle2 } from 'lucide-react';
import { STOCK_OPTIONS, DISCONTINUED } from '../../../lib/fabricLabels';

const btn = 'inline-flex items-center gap-1 h-7 px-2 rounded-md border border-neutral-200 bg-white text-[11px] hover:border-neutral-400 disabled:opacity-40';

// Compact "set stock for selection" buttons: one per status + clear, then discontinued on/off.
export const StockPicker = ({ onPick, onDiscontinued, disabled, testIdPrefix = 'stock-pick' }) => (
  <div className="flex items-center gap-1 flex-wrap" data-testid={`${testIdPrefix}-group`}>
    <span className="text-[10px] uppercase tracking-wider text-neutral-500 mr-1">Stock</span>
    {STOCK_OPTIONS.map((o) => (
      <button key={o.value} type="button" disabled={disabled} onClick={() => onPick(o.value)} title={o.label} className={`${btn} text-neutral-700`} data-testid={`${testIdPrefix}-${o.value}`}>
        <span className={`w-2 h-2 rounded-full ${o.dot}`} />
        <span className="hidden md:inline">{o.label.replace(' available', '')}</span>
      </button>
    ))}
    <button type="button" disabled={disabled} onClick={() => onPick(null)} title="Clear stock status (inherit)" className={`${btn} text-neutral-500`} data-testid={`${testIdPrefix}-clear`}>
      <CircleOff className="w-3 h-3" /> None
    </button>
    {onDiscontinued && (
      <>
        <span className="w-px h-5 bg-neutral-200 mx-1" />
        <button type="button" disabled={disabled} onClick={() => onDiscontinued(true)} title={`Mark as ${DISCONTINUED.label.toLowerCase()}`} className={`${btn} text-red-700 border-red-200`} data-testid={`${testIdPrefix}-discontinued`}>
          <AlertCircle className="w-3 h-3 text-red-600" strokeWidth={2.5} /> <span className="hidden md:inline">Discontinued</span>
        </button>
        <button type="button" disabled={disabled} onClick={() => onDiscontinued(false)} title="Remove the discontinued flag" className={`${btn} text-neutral-500`} data-testid={`${testIdPrefix}-discontinued-off`}>
          <CheckCircle2 className="w-3 h-3" /> <span className="hidden md:inline">Not discontinued</span>
        </button>
      </>
    )}
  </div>
);

export default StockPicker;
